



import React from 'react'
import './CSS/ClothingCaseStudy.css'




const ClothingCaseStudy = () => {


  return (
   <>

<div className='clothing-case-study-container'>
    <div className='clothing-case-study-wrapper'>

        <div><h3> Clothing E-commerce Case Study</h3></div>
    </div>

    <div className='clothing-case-overview-wrapper'>
        <div><h3>Why Did I Create This Project</h3></div>

        <div className='clothing-case-text-wrapper'>
            <div><p> this project was a beginner e-commerce website for me to create for both client and server sides
            Wanted to have the functionality that I've seen elsewhere
              and create a basic e-commerce website for the user.</p></div>
        </div>
    </div>

    <div className='clothing-case-overview-wrapper'>
        <div><h3>Project Statement</h3></div>

        <div className='clothing-case-text-wrapper'>
            <div><p> there were issues such as understanding if I should implement an admin panel if that, 
            and how to just design the entire concept. Focused on animation and religious having the user to have a
             great experience with different choices and also design concepts that will wow a audience.</p></div>
        </div>
    </div>

    <div className='clothing-case-overview-wrapper'>
        <div><h3>Tech Stack</h3></div>

        <div className='clothing-case-text-wrapper'>
            <div><p>Languages Used | Frameworks | Tools - JavaScript, Paypal Payment, MongoDB, React.js, Node.js & Express</p></div>
        </div>
    </div>

    <div className='clothing-case-overview-wrapper'>
        <div><h3>Challenges & Learnings</h3></div>

        <div className='clothing-case-text-wrapper'>
            <div><p> the challenges for this one was really understanding how to organize code on both the client 
            and server side and integrating Paypal payment system that was really challenging.</p></div>
        </div>
    </div>

    <div className='clothing-case-overview-wrapper'>
        <div><h3>Outcome & Impact</h3></div>

        <div className='clothing-case-text-wrapper'>
            <div><p> the outcome I felt was great for this one designed concepts came out pretty well, 
            animation was great, cart functionality, and product page came out good. 
             With. this being the first e-commerce actual website, it was a great start.</p></div>
        </div>
    </div>
</div>




   </>
  )
}

export default ClothingCaseStudy
